import HandleSearchSection from './HandleSearchSection';

export default HandleSearchSection;
